/**
 * Pub/Sub class definition
 */
 class Events {
  constructor() {
    this.eventExist = this.eventExist.bind(this)
    this.subscribe = this.subscribe.bind(this)
    this.publish = this.publish.bind(this)

    this.events = {}
  }

  eventExist(event) {
    return this.events.hasOwnProperty(event)
  }

  subscribe(event, callback) {
    if (!this.eventExist(event)) {
      this.events[event] = []
    }

    return this.events[event].push(callback)
  }

  publish(event, data = {}) {
    if (!this.eventExist(event)) {
      return []
    }

    return this.events[event].map((callback) => callback(data))
  }
}

/**
 * Store class definition
 */
class Store {
  constructor(params) {
    this.dispatch = this.dispatch.bind(this)
    this.commit = this.commit.bind(this)

    this.actions = {}
    this.mutations = {}
    this.state = {}
    this.events = new Events()

    if (params.hasOwnProperty('actions')) {
      this.actions = params.actions
    }

    if (params.hasOwnProperty('mutations')) {
      this.mutations = params.mutations
    }

    this.state = new Proxy(params.state || {}, {
      set: (state, key, value) => {
        state[key] = value

        this.events.publish(`${key}Change`, this.state)

        return true
      },
    })
  }

  dispatch(action, payload, args) {
    if (typeof this.actions[action] !== 'function') {
      console.error(`Action ${action} doesn't exist.`)

      return false
    }

    this.actions[action](this, payload, args)

    return true
  }

  commit(mutation, payload, args) {
    if (typeof this.mutations[mutation] !== 'function') {
      console.error(`Mutation "${mutation}" doesn't exist.`)

      return false
    }

    this.state = Object.assign(
      this.state,
      this.mutations[mutation](this.state, payload, args)
    )

    return true
  }
}

/**
 * Store index definition
 */
const storeIndex = {
  // Actions
  // Perform certain actions and commit the changes to the store
  // These can contain asynchronous actions
  actions: {
    cartUpdate(context, payload) {
      context.commit('cartUpdate', payload)
    },

    cartLoading(context, payload) {
      context.commit('cartLoading', payload)
    },

    cartVisible(context, payload) {
      context.commit('cartVisible', payload)
    },

    addItems(context, payload) {
      const items = [] 

      Object.entries(payload).forEach((updates, entry) => {
        let [id] = updates
        id = parseInt(id)
        const { quantity, estimatedShipping, embroideryPlacementOptions, embroideryPlacementType, embroideryGraphic, embroideryCustomLettering, embroideryFont, embroideryThreadColor } = updates[1]

        let item = {
          id, quantity
        }

        
        var embroideryID = null;
        let itemEmbroidery = "";

        if ($('[name="embroidery"]').length > 0 && !$('[name="embroidery"]').attr('disabled')){
          
          itemEmbroidery = { 
            id: parseInt(document.querySelector('[name="embroidery"]').value),
            quantity: 1
          }
          const { embroideryProduct } = updates[1]

          if (embroideryGraphic != false){
            embroideryID = item.id + '-' + itemEmbroidery.id + '-' + embroideryPlacementOptions + '-' + embroideryPlacementType + '-' + embroideryGraphic + '-' + embroideryThreadColor
          } else if (embroideryPlacementType != false) {
            embroideryID = item.id + '-' + itemEmbroidery.id + '-' + embroideryPlacementOptions + '-' + embroideryPlacementType + '-' + embroideryCustomLettering + '-' + embroideryThreadColor + '-' + embroideryThreadColor
          }
          if (embroideryGraphic == false){
            itemEmbroidery.properties = {
              "__EmbroideryID": embroideryID,
              "Placement": embroideryPlacementOptions,
              "Placement Type": embroideryPlacementType,
              "Custom Lettering": embroideryCustomLettering,
              "Font": embroideryFont,
              "Thread Color": embroideryThreadColor
            }  
          } else {
            itemEmbroidery.properties = {
              "__EmbroideryID": embroideryID,
              "Placement": embroideryPlacementOptions,
              "Placement Type": embroideryPlacementType,
              "Graphic": embroideryGraphic,
              "Thread Color": embroideryThreadColor
            }  
          }
        }

        if (embroideryID != null){
          item.properties = {
            "Estimated Shipping": estimatedShipping,
            "__EmbroideryID": embroideryID
          }
        } else if(estimatedShipping !== '' && estimatedShipping !== false){
          item.properties = {
            "Estimated Shipping": estimatedShipping,
          }
        }

        if (itemEmbroidery !== ""){
          items.push(itemEmbroidery, item)
        } else {
          items.push(item)
        }
      })

      const body = JSON.stringify({
        items,
        sections: document.querySelector('main-cart').id,
        sections_url: window.routes.cart_url
      })

      console.log(body)

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body
      }).then(res => res.json())
        .then(json => {
          context.commit('cartUpdate', json, true);
          
          /* START recurate update atc button */
          const recurateAtcBtns = document.querySelectorAll(`.variant-atc-btn[data-variant-id="${Object.keys(payload)[0]}"]`);
          if(recurateAtcBtns.length > 0){
            recurateAtcBtns.forEach(el => {
              // Hide the price <span> and show the "already in cart" and disable the button<span>
              el.querySelector('span[data-in-cart="true"').style.display='block';
              el.querySelector('span[data-in-cart="false"').style.display='none';
              el.disabled=true;
            })
          }
          /* END recurate update atc button */

        })
        .catch(error => console.error('Error', error))


      // const updates = Object.entries(payload).reduce((updates, entry) => {
      //   const [id] = entry
      //   const { quantity, estimatedShipping } = entry[1]
      //   const itemInCart = context.state.cart.items.find(
      //     (item) => item.id === Number(id)
      //   )
// 
//         return {
//           ...updates,
//           [id]: itemInCart ? itemInCart.quantity + quantity : quantity,
//         }
//       }, {})
//       const body = JSON.stringify({
//         updates,
//         sections: document.querySelector('main-cart').id,
//         sections_url: window.routes.cart_url,
//       })
// 
//       fetch(`${window.routes.cart_update_url}.js`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body,
//       })
//         .then((response) => response.json())
//         .then((json) => {
//           console.log(json)
//           context.commit('cartUpdate', json, true)
//         })
//         .catch((error) => {
//           console.error('Error:', error)
//         })
    },
  },

  // Mutations
  // Perform mutation on the Store state, based on actions above
  // Those should NOT contain asynchronous actions
  mutations: {
    cartUpdate(state, payload, setCartVisible) {
      state.cart = payload

      if (setCartVisible) {
        state.cartVisible = setCartVisible
      }

      return state.cart
    },

    cartLoading(state, payload) {
      state.cartLoading = payload

      return state.cartLoading
    },

    cartVisible(state, payload) {
      state.cartVisible = payload

      return state.cartVisible
    },
  },

  // Initial Store state
  state: {
    cart: window.__CART__,
    cartLoading: false,
    cartVisible: false,
  },
}

// Create a new instance of the Store class
export default new Store(storeIndex)